module.exports = __webpack_public_path__ + "img/img_043@2x.267e6b1b.png";